import * as React from 'react';

export default function SkDrawerCalendar(props) {
    return (
        <h1>Auction</h1>
    );
}